import type { App } from 'utils/app/types';

/**
 * Returns a function that determines if an event is one of an array of types.
 */
export function isOneOf(eventTypes: string[] | object) {
  const eventTypesSet = new Set(Array.isArray(eventTypes) ? eventTypes : Object.values(eventTypes));

  return function isType(event: App.Event): boolean {
    return eventTypesSet.has(event.type);
  };
}
